/**
 * Helper function to check if the current project is a kickstarter account
 */
export function isKickstarterAccount(accountType: null | string): boolean {
  return accountType === "kickstarter";
}

/**
 * Helper function to check if the user has any kickstarter project
 */
export function hasKickstarterProject(
  projects: Array<{ accountType: null | string }>,
): boolean {
  return projects.some((project) => project.accountType === "kickstarter");
}
